import { Heading } from '@seek/ai-elements';
import { IconAI, Inline } from 'braid-design-system';

import { CareerFeedBetaBadge } from './CareerFeedBetaBadge';

export const CareerFeedAIHeading = ({
  headingText,
}: {
  headingText: string;
}) => (
  <Inline space="xsmall" alignY="center">
    <Heading level="4" icon={<IconAI />}>
      {headingText}
    </Heading>
    <CareerFeedBetaBadge tone="neutral" />
  </Inline>
);
